import { Component, Input, OnChanges } from '@angular/core';
import { FormGroupDirective, UntypedFormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { FilterEvent } from '../models/filter-event';

@Component({
    selector: 'app-base-filter',
    templateUrl: './base-filter.component.html',
    styleUrls: ['./base-filter.component.scss'],
    standalone: true,
})
export class BaseFilterComponent implements OnChanges {
    @Input()
    columnName: string;

    _headerName: string;

    @Input()
    set headerName(value: string) {
        this._headerName = value;
    }

    get headerName(): string {
        if (this.columnRequiered === true) {
            return `${this._headerName} *`;
        } else {
            return this._headerName;
        }
    }

    @Input()
    columnRequiered: boolean = false;

    filterControlName: string;

    isFilled: boolean = false;

    constructor(protected filtersFormDirective: FormGroupDirective) {}

    ngOnChanges() {
        this.initFilters();
    }

    public register(): Observable<FilterEvent> {
        // To be overrided
        console.warn('Cette méthode ne devrait pas être appellée.');
        return of(null);
    }

    initFilters() {
        this.filterControlName = 'filter_' + this.columnName;
        this.filtersFormDirective.form.addControl(this.filterControlName, new UntypedFormControl());
    }

    public reset() {
        console.warn('Cette méthode ne devrait pas être appellée.');
    }
}
